import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Submenu extends Component {
  static defaultProps = {
    className: null,
    items: null,
    onMenuItemClick: null,
    root: false,
    menuActiveIndex: null,
  };

  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    onMenuItemClick: PropTypes.func,
    root: PropTypes.bool,
    menuActiveIndex: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = { activeIndex: props.menuActiveIndex };
  }

  onMenuItemClick(event, item, index) {
    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    // execute command
    if (item.command) {
      item.command({ originalEvent: event, item });
    }

    if (index === this.state.activeIndex) this.setState({ activeIndex: null });
    else this.setState({ activeIndex: index });

    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick({
        originalEvent: event,
        item,
      });
    }
  }

  renderLinkContent(item) {
    const submenuIcon = item.items && (
      <i className="pi pi-fw pi-angle-down menuitem-toggle-icon" />
    );
    const badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

    return (
      <>
        <i className={item.icon} />
        <span>{item.label}</span>
        {submenuIcon}
        {badge}
      </>
    );
  }

  renderLink(item, i) {
    const content = this.renderLinkContent(item);

    if (item.to) {
      return (
        <NavLink
          activeClassName="active-route"
          to={item.to}
          onClick={e => this.onMenuItemClick(e, item, i)}
          exact
          target={item.target}
        >
          {content}
        </NavLink>
      );
    }
    return (
      <a href={item.url} onClick={e => this.onMenuItemClick(e, item, i)} target={item.target}>
        {content}
      </a>
    );
  }

  render() {
    const items =
      this.props.items &&
      this.props.items.map((item, i) => {
        const active = this.state.activeIndex === i;
        const styleClass = classNames(item.badgeStyleClass, {
          'active-menuitem': active && !item.to && !item.command,
        });
        // condição original nao tinha o !item.command, adicionei para evitar que o item ficasse selecionado
        // quando nao tivesse o item.to. Assim se preencher o command tmb vai funcionar como originalmente

        return (
          <li className={styleClass} key={i} title={item.title}>
            {item.items && this.props.root === true && <div className="arrow" />}
            {this.renderLink(item, i)}
            <Submenu items={item.items} onMenuItemClick={this.props.onMenuItemClick} />
          </li>
        );
      });

    return items ? <ul className={this.props.className}>{items}</ul> : null;
  }
}

export class Menu extends Component {
  static defaultProps = {
    model: null,
    onMenuItemClick: null,
  };

  static propTypes = {
    model: PropTypes.array,
    onMenuItemClick: PropTypes.func,
    activeIndex: PropTypes.number,
  };

  render() {
    return (
      <div className="layout-menu-container">
        <Submenu
          menuActiveIndex={this.props.activeIndex}
          items={this.props.model}
          className="layout-menu"
          onMenuItemClick={this.props.onMenuItemClick}
          root
        />
      </div>
    );
  }
}
